// use checkout.globals as the globals hash in jemplate.process
Checkout.Globals = function(checkout) {
	var globals = this;

	this.getDateRange = function(fromDate, toDate) {
		if (!toDate)
			toDate = fromDate;
		if (!toDate || !fromDate)
			return "";
		var fromDateStr = isoDateFormatter( fromDate, true );
		var toDateStr = isoDateFormatter( toDate, true );
		if (fromDate == toDate)
			return fromDateStr;
		if (fromDateStr.substring(0,3) == toDateStr.substr(0, 3)) // same month
			return fromDateStr + " - " + toDateStr.substring(4);
		return fromDateStr + " - " + toDateStr;
	};
	this.getDateRangeLong = function(fromDate, toDate) {
		if (!toDate)
			toDate = fromDate;
		var fromDateStr = isoDateFormatter( fromDate, false );
		var toDateStr = isoDateFormatter( toDate, false );
		if (fromDate == toDate)
			return fromDateStr;
		if (fromDateStr.substring(0,3) != toDateStr.substr(0, 3)) // different month
			return fromDateStr + " - " + toDateStr;
		toDateStr = isoDateFormatter( toDate, true );
		return fromDateStr + " - " + toDateStr.substring(4);
	};

	this.commaSeparate = commaSeparate;

	// endeca jemplate globals
	this.fixNavState = fixNavState;

	this['employeeLoggedIn'] = checkout.config.employeeLoggedIn;
	this['isWholesaleCustomer'] = checkout.config.isWholesaleCustomer;
	var _loggedInEmployee = checkout.config.loggedInEmployee;
	_loggedInEmployee.permission = function(cat) {
		return checkout.config.employeePermissions[cat];
	};
	this.loggedInEmployee = _loggedInEmployee;


};


